var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "24px",
    viewBox: "0 0 33 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glyph") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STENI-pattern-generator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "choose-product-menu-open",
    transform: "translate(-1442.000000, -178.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1108.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(334.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.5 L30,11.5",
    id: "shape-2",
    transform: "translate(15.000000, 11.500000) rotate(-180.000000) translate(-15.000000, -11.500000) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "shape-1",
    transform: "translate(25.000000, 11.500000) scale(-1, 1) rotate(-180.000000) translate(-25.000000, -11.500000) ",
    points: "19 23 31 11.5 19 0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightActive);
export default __webpack_public_path__ + "static/media/arrow-right-active.d88c54ab835a003ddc73ef1ea96f72f8.svg";
export { ForwardRef as ReactComponent };